
const state = {
  unreadNotices: [],
  unreadNum: 0
}

const mutations = {
  SET_NOTICES: (state: any, payload: any) => {
    state.unreadNotices = payload.items
    state.unreadNum = payload.totalCount
  }

}

// const noticeRestServiceProxy = new NoticeRestServiceProxy()
const actions = {
  getNotices({ commit }: any, params: any) {
    return new Promise((resolve, reject) => {
      // noticeRestServiceProxy.list(params).then(res => {
      //   commit('SET_NOTICES', res)
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
